<script lang="ts" setup>
interface Props {
  height?: number | string
}

const props = withDefaults(defineProps<Props>(), {
  height: 200,
})

const fallbackHeight = computed(() => {
  return typeof props.height === 'number' ? `${props.height}px` : props.height
})
</script>

<template>
  <ClientOnly>
    <slot />
    <template #fallback>
      <div
        class="flex animate-pulse items-center justify-center rounded-lg bg-neutral-600/10"
        :style="{ height: fallbackHeight }"
      />
    </template>
  </ClientOnly>
</template>
